import { useRouter } from "next/router";

export const useTranslatedRoute = () => {
    const router = useRouter();

    const getLocale = (): string | null => router.locale ?? null;

    const getLocaleStr = (locale?: string | null): string => {
        router.locale = locale ?? router.locale;
        const _locale = locale ?? getLocale();
        return _locale ? `/${_locale}` : "";
    };

    const getTranslatedUrl = (path: string, locale?: string | null) => {
        return `${getLocaleStr(locale)}${path}`;
    };

    return getTranslatedUrl;
};
